module.exports = __webpack_public_path__ + "img/A11_1.51361375.png";